import { type FC } from 'react';
import Chevron from '@assets/img/icons/chevron.svg?react';

import css from './styles.module.scss';

const ArrowsRightAnimation: FC = () => {
  return (
    <div className="size-8 flex -space-x-[1.375rem] justify-center">
      <Chevron className={`size-8 min-w-8 ${css.arrowAnimation}`} />
      <Chevron className={`size-8 min-w-8 ${css.arrowAnimation}`} />
      <Chevron className={`size-8 min-w-8 ${css.arrowAnimation}`} />
    </div>
  );
};

export default ArrowsRightAnimation;
